import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { EmployeeList } from "./EmployeeList";
import { EmployeesSearch } from "./EmployeesSearch";

// تبويب الفريق: بحث + فلترة بالدور + شبكة بطاقات الموظفين.
export const EmployeesTeamTab = ({ employees, branchNames }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState("");
  const [role, setRole] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return employees.filter((e) => {
      if (role && e.role !== role) return false;
      if (!q) return true;
      return (
        (e.name || "").toLowerCase().includes(q) ||
        (e.email || "").toLowerCase().includes(q)
      );
    });
  }, [employees, query, role]);

  return (
    <div className="grid gap-5" data-testid="employees-team-tab">
      <EmployeesSearch query={query} setQuery={setQuery} role={role} setRole={setRole} />
      {filtered.length === 0 ? (
        <p className="rounded-2xl border border-border/40 py-8 text-center text-sm text-muted-foreground shadow-neu-sm">
          {query || role ? t("employees.empty.search") : t("app.none")}
        </p>
      ) : (
        <EmployeeList employees={filtered} branchNames={branchNames} />
      )}
    </div>
  );
};
